import { useState } from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// PAGES

// USER
import Home from './pages/Home';
import FAQs from './pages/FAQs';
import OpenTicket from './pages/OpenTicket';
import CheckTicket from './pages/CheckTicket';
import TicketCreated from './pages/TicketCreated';
import TicketStatus from './pages/TicketStatus';
import BSCSAdmissions from './pages/faqs/BSCSAdmissions';
import BSCSCourseSubjects from './pages/faqs/BSCSCourseSubjects';
import BSCSCurriculum from './pages/faqs/BSCSCurriculum';
import LOA from './pages/faqs/LeaveOfAbsence';
import MRR from './pages/faqs/MRR';
import Calendar from './pages/faqs/AYCalendar';
import Facilities from './pages/faqs/Facilities';
import Org from './pages/faqs/StudentOrganizations';
import MSBI from "./pages/faqs/MSBI";
import MSCS from "./pages/faqs/MSCS";
import PHDCS from "./pages/faqs/PHDCS";
import DocView from "./pages/faqs/DocumentViewer";

// ADMIN
import Login from './pages/Login';
import Logout from './pages/Logout';
import DBAdmin from './pages/dashboard';
import OpenAccount from './pages/OpenAccount'
import CloseAccount from './pages/CloseAccount'
import ChangePassword from './pages/ChangePassword'
import SettingsUser from './pages/SettingsUser'

function App() {
  return (
    <div>
      <Router>
        <Routes>
          {/* USER SIDE */}
          <Route path="/" element={<Home />} exact/>
          <Route path="/FAQs" element={<FAQs />} />
          <Route path="/Openticket" element={<OpenTicket />} />
          <Route path="/CheckTicket" element={<CheckTicket />} />
          <Route path="/TicketCreated" element={<TicketCreated />} />
          <Route path="/TicketStatus/:id" element={<TicketStatus />} />
          <Route path="/FAQs/BSCSAdmissions" element={<BSCSAdmissions />} />
          <Route path="/FAQs/BSCSCourseSubjects" element={<BSCSCourseSubjects />} />
          <Route path="/FAQs/BSCSCurriculum" element={<BSCSCurriculum />} />
          <Route path="/FAQs/LOA" element={<LOA />} />
          <Route path="/FAQs/MRR" element={<MRR />} />
          <Route path="/FAQs/AYCalendar" element={<Calendar />} />
          <Route path="/FAQs/Facilities" element={<Facilities />} />
          <Route path="/FAQs/StudentOrganizations" element={<Org />} />
          <Route path="/FAQs/PHDCS" element={<PHDCS />} />
          <Route path="/FAQs/MSCS" element={<MSCS />} />
          <Route path="/FAQs/MSBI" element={<MSBI />} />
          <Route path="/FAQs/DocumentViewer/:handle" element={<DocView />} />

          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/openaccount" element={<OpenAccount />} />
          <Route path="/closeaccount" element={<CloseAccount />} />
          <Route path="/SettingsUser" element={<SettingsUser />} />
          <Route path="/dashboard" element={<DBAdmin />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;